module.exports = __webpack_public_path__ + "static/media/plane-orange.8486ba36.svg";